import access_role from './access_role.js';
import branch from './branch.js';
import colors from './colors.js';
import company from './company.js';
import contract_type from './contract_type.js';
import department_company from './department_company.js';
import employee_document_type from './employee_document_type.js';
import feature_access_list from './feature_access_list.js';
import feature_roles from './feature_roles.js';
import general_document_types from './general_document_types.js';
import holiday_types from './holiday_types.js';
import holidays from './holidays.js';
import icons from './icons.js';
import leave_category from './leave_category.js';
import leave_restriction_rules from './leave_restriction_rules.js';
import settings from './settings_lookup.js';

export default [
	access_role,
	branch,
	colors,
	company,
	contract_type,
	department_company,
	employee_document_type,
	feature_access_list,
	feature_roles,
	general_document_types,
	holiday_types,
	holidays,
	icons,
	leave_category,
	leave_restriction_rules,
	settings
];
